module.exports = __webpack_public_path__ + "5d733862dc71d3a89ba2704270864c23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/Nathan_Allen_Cocoa.jpg
// module id = 21
// module chunks = 0